import type { ReactNode } from 'react';

/**
 * El semáforo de la marca. Cinco tonos y ni uno más — el color NO es decorativo,
 * dice qué pasó (regla de tbit-canvas):
 *
 *   good  mint    el dato real: se confirmó, respondieron, aceptó
 *   warn  coral   fricción que espera: borrador, invitación sin contestar
 *   bad   coral   fricción que se cayó: rechazado, desconectado
 *   info  púrpura lo que está en marcha: encolado, enviado, en preselección
 *   muted tinta   lo que todavía no significa nada: sugerido, descartado
 */
export type ToneName = 'good' | 'warn' | 'bad' | 'info' | 'muted';

interface Props {
  tone: ToneName;
  children: ReactNode;
  className?: string;
}

export default function Tone({ tone, children, className }: Props) {
  return (
    <span className={className ? `tone ${className}` : 'tone'} data-tone={tone}>
      {children}
    </span>
  );
}
